module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Logga in":"Sign in","För företag":"For business","För talanger":"For talents"},"sv":{"Logga in":"Logga in","För företag":"För företag","För talanger":"För talanger"}}')
  delete Component.options._Ctor
}
